/* eslint-disable no-console */
// import StyledAside, { Wrap } from './styles';
import StyledAside from './styles';

import LayersCatalog from './components/LayersCatalog';
import MenuLayers from './components/MenuLayers';
import NavButton from './components/NavButton';

import AppContext from '../../services/context';
// import DynamicLabels from '../Icons/DynamicLabels';


import Icon from '@map/components/Icons';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
// import * as turf from '@turf/turf';
/**
 * Tooltip é uma ferramenta utilizada para especificar informações extras
 * sobre algo quando o usuário move o ponteiro do mouse sobre um elemento.
 */
import Tooltip from 'components/Tooltip';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
// import L from 'leaflet';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useContext usado para forcener uma maneira de passar dados
 * pela arvore de componentes sem ter que passar props manualmente
 * em todos os níveis.
 * 
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 */
import { useState, useEffect, useContext, useCallback } from 'react';
/**
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 */
import { useModule } from 'views/MapView/hooks';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
// import { useMap } from 'views/MapView/hooks';

const ReportContent = (props) => (
  <div style={{ background: 'white', width: '100%' }}>
    <p>Conteúdo de relatórios</p>
  </div>
);

const MenuPanel = (props) => {
  const [component, setComponent] = useState(null);
  const [menuIsOpened, setMenuIsOpened] = useState(false);
  // initMenu diz se o menu deve ser inicializado ao abrir a página, também desabilita a função de fechar o menu lateral, já que se infere que os sistemas que inicializam automaticamente o menu, têm a tela grande
  const [activeMenu, setActiveMenu] = useState(null);
  const context = useContext(AppContext);
  const { getElement } = useModule();
  const { genericSetContextProp } = context;




  // const { map, layers } = useMap();  

   // Obtem camadas 'criadas' ou 'importadas' e que tenham rótulos configurados visíveis
  //  const getLayersToRepositionLabels = () => {    
  //   return layers.filter((l) => {      
  //     return (l.type === 'importada' || l.type === 'criada')            
  //             && ["Polygon", "MultiPolygon", "Geometry", "GeometryCollection"].includes(l.dataType)
  //             && l.statusLabelVisibility
  //             && l.selectedLabelColumn
  //   });
  // };

  // Verifica se há camadas relevantes e rótulos a serem reposicionados
  // const hasRelevantLayers = layers.some((l) => l.type === 'importada' || l.type === 'criada');
  // const hasLabelsToReposition = getLayersToRepositionLabels().length > 0;
  // const isActive = hasRelevantLayers && hasLabelsToReposition;
  // const dynamicLabelFillColor = isActive ? '#3c71dd' : '#ABABAB';
  

  const changeMenuContent = useCallback(
    (Component) => (e) => {
      if (!menuIsOpened) setMenuIsOpened(true);
      setComponent(Component);
      if (e) {
        setActiveMenu(e.target.id);
      }
    },
    [menuIsOpened]
  );

  const onChangeWindowSize = useCallback(
    (mediaQuery) => {
      if (mediaQuery.matches) {
        // If media query matches
        setMenuIsOpened(false);
      } else {
        setMenuIsOpened(true);
        // Colocar aqui o menu que será carregado por padrão
        // Passado como string(provisóriamente) pois estava dando erro ao passar props, ou tentar usar context dentro do component
        changeMenuContent('layers')();
        setActiveMenu('layers');
      }
    },
    [changeMenuContent]
  );

 

  // Obtem polígono a partir da área de visualização corrente do mapa
  // const getPolygonFromBoundsMaps = () => {    
  //   // Obtém coordenadas de envelope de visualização do mapa
  //   let mapBounds = map.getBounds();    
  //   // Gera geometria a partir do enquadramento do mapa
  //   return L.rectangle(mapBounds).toGeoJSON();
  // };

  // // Obtem polígono a partir da área de visualização corrente do mapa
  // const intersectFeature = (feature, intersecter) => {
  //   return turf.intersect(feature.toGeoJSON(), intersecter, feature.feature.properties);
  // };

  // Reposiciona rótulos de camadas(vetoriais) no mapa
  // const repositionLabels = (e) => {        
  //   let layersToRepositionLabels = getLayersToRepositionLabels();     
  //   let polygonBoundMap = getPolygonFromBoundsMaps();
    
  //   // Reposiciona rótulos de cada feição de camada que intersectar
  //   // com a área de visualização do mapa
  //   layersToRepositionLabels.forEach((ltrl) => {            
  //     ltrl.leafletLayer.eachLayer((fl) => {          
  //       let featureIntersected = intersectFeature(fl, polygonBoundMap);
  //       if (featureIntersected) { 
  //         // Obtem feição ponto da centroid         
  //         let centroidFeature = turf.centroid(featureIntersected);
  //         let latCentroidFeature = centroidFeature.geometry.coordinates[1];
  //         let lngCentroidFeature = centroidFeature.geometry.coordinates[0];          
  //         // Reposiciona rótulo para mesma localização da centroid da feição resultande da interseção
  //         fl.getTooltip().setLatLng({lat: latCentroidFeature, lng: lngCentroidFeature})
  //       }        
  //     });
  //   });    
  // };

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    onChangeWindowSize(mediaQuery); // Call listener function at run time
    mediaQuery.addEventListener(true, onChangeWindowSize); // Attach listener function on state changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * @returns Um botao de um circulo com o '+' no meio referente a adição de camadas
   * após clicado o botao retorna um modal onde é possivel adicionar camadas atraves
   * do catalogo, de importação e tambem usando links do geoserviço, e outras customi
   * zaçoes como cores e rotulos
   * Nele é possivel tambem ver um preview da camada que está para ser adicionada
   */
  return (
    <>
      <LayersCatalog />
      <ClickAwayListener
        onClickAway={(e) => {
          setMenuIsOpened(false);
        }}
      >
        <StyledAside
          isOpened={menuIsOpened}
          isHided={context.hidedInterface}
          toolBar={props.toolBar}
        >
          <nav>
            <ul>
              {getElement('CPN-MP-MENU_LAYERS') && (
                <li>
                  <NavButton
                    type="button"
                    Icon={<Icon i="map-layersmenu-layer" />}
                    onClick={changeMenuContent('layers')}
                    id="layers"
                    active={activeMenu === 'layers'}
                  >
                    Camadas
                    <Tooltip title="Adicionar camadas">
                      <button
                        className="add-layer-button"
                        onClick={(e) => {
                          e.stopPropagation();
                          genericSetContextProp('layersCatalogIsOpened', true);
                        }}
                      >
                        <Icon i="map-layersmenu-plus" width="18" height="18" />
                      </button>
                    </Tooltip>
            
                  </NavButton>
                </li>
              )}
              {getElement('CPN-MP-MENU_REPORT') && (
                <li>
                  <NavButton
                    type="button"
                    Icon={<Icon i="map-reportmenu-report" />}
                    onClick={changeMenuContent('report')}
                    id="report"
                    active={activeMenu === 'report'}
                  >
                    Relatório
                  </NavButton>
                </li>
              )}
            </ul>
          </nav>

          <div className="content" >

            {/* <Wrap active={isActive}>
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        repositionLabels();
                      }}
                    >
                      <Tooltip title="Ajustar rótulos">
                        <span>
                          <DynamicLabels fill={dynamicLabelFillColor} />
                        </span>
                      </Tooltip>
                    </span>
            </Wrap> */}

            {component === 'layers' && getElement('CPN-MP-MENU_LAYERS') && (
              <MenuLayers appContext={context} />
            )}
            {component === 'report' && <ReportContent />}
          </div>
        </StyledAside>
      </ClickAwayListener>
    </>
  );
};

MenuPanel.properties = {
  id: 'CPN-MENU_PANEL',
  alias: 'Painel de menu',
  description: '...',
};

export default MenuPanel;
